<template>
  <div class="mt-4">
    <b-container class="p-0 m-0 data-volume-region-container">
      <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
        <template slot="header">
          <b-row slot="header">
            <b-col>
                <span class="h4 font-weight-bold mb-0 nowrap" v-if="title">{{title}}</span>
            </b-col>
            <b-col class="font-weight-bold mb-0 text-right nowrap">
                  <span class="h6 font-weight-bold mb-0" v-if="cTitle">
                    <base-button size="xs" type="secondary" class="p-1 border-radius-none" @click="changeDataRegionTab(cTitle)"
                                 v-bind:class="btnActivated === cTitle ? 'bg-warning text-white' : ''"
                    >{{cTitle}}</base-button>
                  </span>
                  <span class="h6 font-weight-bold mb-0 " v-if="dTitle">
                    <base-button size="xs" type="secondary" class="p-1 border-radius-none" @click="changeDataRegionTab(dTitle)"
                                 v-bind:class="btnActivated === dTitle ? 'bg-warning text-white' : ''"
                    >{{dTitle}}</base-button>
                  </span>
                  <span class="h6 font-weight-bold mb-0" v-if="mTitle">
                    <base-button size="xs" type="secondary" class="p-1 border-radius-none" @click="changeDataRegionTab(mTitle)"
                                 v-bind:class="btnActivated === mTitle ? 'bg-warning text-white' : ''">
                      {{mTitle}}</base-button>
                  </span>
                  <span class="h6 font-weight-bold mb-0" v-if="yTitle">
                    <base-button size="xs" type="secondary" class="p-1 mr-1 border-radius-none" @click="changeDataRegionTab(yTitle)"
                                 v-bind:class="btnActivated === yTitle ? 'bg-warning text-white' : ''">
                      {{yTitle}}</base-button>
                  </span>
              <slot name="icon" class="pl-2">
                <b-icon
                    icon="question-circle"
                    variant="orange"
                    class="mr-1 vertical-align-35"
                    v-b-tooltip.hover.top="tooltip">
                </b-icon>
              </slot>
              <slot name="icon" class="pl-2 ml-2">
                <b-icon
                    :icon="icon1"
                    variant="orange"
                    class="vertical-align-35"
                    @click="dataVolumeRegionToggle()"
                    v-b-tooltip.hover.top="'Click here to enable or disable this item'"
                ></b-icon>
              </slot>
            </b-col>
          </b-row>
        </template>
        <transition name="slide-fade">
          <b-row v-if="toggleStatus">
            <div class="text-center w-100">
              <b-icon icon="three-dots"
                      class="text-center" animation="cylon"
                      font-scale="4"
                      v-if="loadingStatus"></b-icon>
            </div>
            <b-col v-if="!loadingStatus">
              <b-card no-body class="border-0 mb-0">
                <div id="data_volume_map" class="map-canvas"
                     style="height: 600px;"></div>
                <div :id="'legend' + btnActivated" class=" br-white mr-2 "></div>
              </b-card>
            </b-col>
          </b-row>
        </transition>
      </card>

    </b-container>
  </div>
</template>
<!-- Heatmap visualization library -->

<!-- <script async
    src="https://maps.googleapis.com/maps/api/js?key=Pq2eSOjrXv3s7jjOHYrGF13vvnykXAzP6nkfrPf1&libraries=visualization&callback=initMap">
</script> -->
<script>
import cardOpenStatusDirective from "@/common/directive/card-open-status-directive";
//import initService from "@/common/api-services/init-service";
import configDirective from "@/common/directive/config-directive";

// //https://www.npmjs.com/package/google-maps
//import {Loader} from 'google-maps';
import {Loader, LoaderOptions} from 'google-maps';

export default {
    props: {
      type: {
        type: String,
        default: 'primary'
      },
      icon: String,
      title: String,
      cTitle: String,
      dTitle: String,
      mTitle: String,
      yTitle: String,
      iconClasses: [String, Array],
      tooltip: String,
    },
    data() {
      return {
        toggleStatus: false,
        loadingStatus: true,
        icon1: 'arrow-right-square',
        downIcon: 'arrow-down-square',
        rightIcon: 'arrow-right-square',
        btnActivated: 'Current',
        lat: 0,
        lng: 0,
        weight: 0,
        color: "#5e72e4",
        markerList: [],
        gradient : [
          "rgba(102, 255, 0, 0)",
          "rgba(102, 255, 0, 1)",
          "rgba(147, 255, 0, 1)",
          "rgba(193, 255, 0, 1)",
          "rgba(238, 255, 0, 1)",
          "rgba(244, 227, 0, 1)",
          "rgba(249, 198, 0, 1)",
          "rgba(255, 170, 0, 1)",
          "rgba(255, 113, 0, 1)",
          "rgba(255, 57, 0, 1)",
          "rgba(255, 0, 0, 1)",
        ]
      }
    },

    async mounted() {
      // Initializing with API key
      // const options: LoaderOptions = {libraries: ['visualization']};
      const loader = new Loader( configDirective.getGoogleApiKey(), {libraries:['visualization']} );
      const google = await loader.load();

      this.getCardStatus();

      this.$root.$on('dataVolumeTrendByRegion', (event) => {
        try {
          //console.log('ON dataVolumeTrendByRegion ')
          setTimeout(() => {
            this.initMap(google, event);
          }, 5200);
          this.loadingStatus = false;
        } catch (e) {
          //console.error('ON dataVolumeTrendByRegion');
          console.error(e);
        }
      });
    },
    methods: {
      getCardStatus() {
        if (cardOpenStatusDirective.getOpenCardStatus()) {
          let cardStatus = cardOpenStatusDirective.getOpenCardStatus()['dataVolume-map-collapse'];
          if (cardStatus) {
            this.icon1 = this.downIcon;
            this.toggleStatus = cardStatus;
          }
        }
      },

      async initMap(google, data) {
        //if (window?.google) return window.google;
        try {
          let configData = configDirective.getConfigData();
          let heatMapData = [];
          let bound = new google.maps.LatLngBounds();
          let map_center = configData['site-settings']['map_center'].split(',');
          let center = new google.maps.LatLng(map_center[0], map_center[1],true);
          let zoom = configData['site-settings']['map_zoom'] ? configData['site-settings']['map_zoom'] : 3;
          //console.log('[DataVolumeByRegion.vue] mapDiv: data_volume_map');
          //console.log("[map]:",center,zoom);

          // const map = new google.maps.Map(document.getElementById('data_volume_map'), {
          //   center: {lat: -34.397, lng: 150.644},
          //   zoom: 8,
          // });
          // map.setCenter(center);
          // map.setZoom(zoom);
          // map.setMapTypeId(google.maps.MapTypeId.ROADMAP);

          // Initialize map with center, zoom and mapTypeId
          const map = new google.maps.Map(document.getElementById('data_volume_map'), {
            center: center,
            zoom: zoom,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
          });

          // console.log("Map data =>", data);
          let dataCheck = data.includes('NULL');
          // console.log("Map data inclues 'NULL' =>", dataCheck);
          if (dataCheck) {
            // if no data, show single test marker in center
            let icon_cgreen = 'https://i.imgur.com/CM5c7BE.png';

            let marker = new google.maps.Marker({
            position: center,
            map: map,
            animation: google.maps.Animation.DROP,
            title: 'Default Marker',
            icon: icon_cgreen
            });

            let imsi = 'NO DATA';
            let connectiontype = 'DEFAULT MARKER';
            let contentString =
            '<div id="content">' +
            //"<p></p>" +
            '<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">IMSI: </span> ' +
            imsi +
            "</p>" +
            '<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">Connection Type: </span> ' +
            connectiontype +
            "</p>" +
            "</div>";
            let infowindow = new google.maps.InfoWindow({
              content: contentString,
            });

            google.maps.event.addListener(marker, 'click', function () {
            infowindow.open(map, marker);
            });

          } else {
            // Data visualization layer and marker point setup

            //if (!data.includes('NULL')) {
              // console.log('data:',data);
            for (let i = 0; i < data.length; i++) {
              // console.error('map_data:',data[i]);

              let imsi = data[i].imsi;
              let connectiontype = data[i].radio;
              // let myLatLng = new google.maps.LatLng(parseFloat(data[i].lat_lon.split(',')[0]), parseFloat(data[i].lat_lon.split(',')[1]));

              this.addMarker(map, data[i].lat_lon, connectiontype, imsi, bound, configData);

              heatMapData.push({
                location: new google.maps.LatLng(parseFloat(data[i].lat_lon.split(',')[0]), parseFloat(data[i].lat_lon.split(',')[1])),
                wieght: data[i].weight,
              });

              // bounds.extend(new google.maps.LatLng(parseFloat(data[i].lat_lon.split(',')[0]), parseFloat(data[i].lat_lon.split(',')[1])));
              // map.fitBounds(bounds);

              // if (data[i].lat_lon) {
                // console.log('map_data:',data[i].lat_lon);
                // console.log(typeof parseFloat(data[i].lat_lon.split(',')[0]))
                // let childData = {
                //   location: new google.maps.LatLng(parseFloat(data[i].lat_lon.split(',')[0]), parseFloat(data[i].lat_lon.split(',')[1])),
                //   weight: data[i].weight,
                // };
                // heatMapData.push(childData);
                // if (map && data[i].lat_lon && data[i].radio && data[i].imsi && bound && configData)
              // }
            }
            if (heatMapData.length <= 1) {
              map.setZoom(15);
              if (heatMapData.length === 0) {
                return;
              }
            }
            // console.log(heatMapData);
            //
            let heatmap = new google.maps.visualization.HeatmapLayer({
              data: heatMapData,
            });
            heatmap.setMap(map);
            heatmap.set('radius', 30);
            map.addListener("zoom_changed", () => {
              this.toggleMarker(map, this.markerList);
            });
            //}
            // Set map center and zoom to fit all markers
            google.maps.event.addListener(map, 'zoom_changed', function() {
              const zoomChangeBoundsListener = google.maps.event.addListener(map, 'bounds_changed', function(event) {
              // Initial zoom level check
              if (this.getZoom() > 15 && this.initialZoom == true) {
                  // Change max/min zoom here
                  this.setZoom(15);
                  //map.setZoom(15);
                  this.initialZoom = false;
              }
              google.maps.event.removeListener(zoomChangeBoundsListener);
                });
            });
            map.initialZoom = true;
            map.fitBounds(bound);

          }
        } catch (e) {
          console.error('on initMap');
          console.error(e);
        }

      },

      addMarker(map, lat_lon, connectiontype, imsi, bounds, configData) {
        // console.log('addMarker:',lat_lon,connectiontype,imsi,bounds,configData);

        //let icon_3green = "https://i.imgur.com/vSpGkBd.png";
        //let icon_4green = "https://i.imgur.com/8jLOZnY.png";
        let icon_3yellow = "https://i.imgur.com/SU1eH1v.png";
        let icon_4yellow = "https://i.imgur.com/theJhNx.png";
        //let icon_cgreen = "https://i.imgur.com/CM5c7BE.png";
        let icon_cyellow = "https://i.imgur.com/2eE096C.png";
        let sel_icon = "";

        if (connectiontype === "3G") {
          // yellow triangle
          sel_icon = icon_3yellow;
        } else if (connectiontype === "LTE") {
          // yellow square
          sel_icon = icon_4yellow;
        } else {
          sel_icon = icon_cyellow;
        }

        let latlngStr = lat_lon.split(",", 2);
        let latlng = {lat: parseFloat(latlngStr[0]), lng: parseFloat(latlngStr[1])};

        let contentString =
          '<div id="content">' +
          //"<p></p>" +
          '<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">IMSI: </span> ' +
          imsi +
          "</p>" +
          '<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">Connection Type: </span> ' +
          connectiontype +
          "</p>" +
          "</div>";
        let infowindow = new google.maps.InfoWindow({
          content: contentString,
        });

        let marker = new google.maps.Marker({
          position: latlng,
          map: map,
          title: "Point",
          icon: sel_icon,
          visible: configData["site-settings"]["use_map"] === "markerclusters",
        });
        marker.addListener("click", function () {
          infowindow.open(map, marker);
        });
        if (typeof bounds !=='undefined') {
          // bounds.extend(marker.getPosition());
          bounds.extend(new google.maps.LatLng(parseFloat(lat_lon.split(',')[0]), parseFloat(lat_lon.split(',')[1])));

        }
        this.markerList.push(marker);
        return marker;
      },

      /*
      initGradients(period) {
        if (
          typeof document.getElementById("legend" + period) === "undefined" ||
          typeof document.getElementById("legend"+ period).innerHTML === 'undefined' ||
          document.getElementById("legend" + period) === null ||
          document.getElementById("legend" + period).innerHTML === ""
        ) {
          setTimeout(this.initGradients, 1500, period);
          return;
        }
        var gradientCss = "(left";
        for (var i = 0; i < this.gradient.length; ++i) {
          gradientCss += ", " + this.gradient[i];
        }
        gradientCss += ")";
        document.getElementById("legendGradient" + period).style.backgroundColor =  "-webkit-linear-gradient" + gradientCss;
        document.getElementById("legendGradient" + period).style.backgroundColor = "-moz-linear-gradient" + gradientCss;
        document.getElementById("legendGradient" + period).style.backgroundColor = "-o-linear-gradient" + gradientCss;
        document.getElementById("legendGradient" + period).style.backgroundColor = "linear-gradient" + gradientCss;
        var maxIntensity = 10;
        var legendWidth = 250;
        let max = undefined;
        //LegendTitle
        if (
          document.getElementById("legend" + period).innerHTML.indexOf("Data Volume") < 1
        ) {
          if (typeof max === "undefined" || max < 10) {
            let legendCardTitle = document.getElementById('legend' + period);
            var legendGradientCss = document.createElement('div');
            legendGradientCss.innerHTML = "<b>Data Volume (scale 1 - 10)</b>";
            legendCardTitle.appendChild(legendGradientCss)
          } else {
            let legendCardTitle1 = document.getElementById('legend' + period);
            var legendGradientCss1 = document.createElement('div');
            legendGradientCss1.innerHTML = '<b>Data Volume (0 - " + max + " MB)</b>';
            legendCardTitle1.appendChild(legendGradientCss1)

          }
        }

        // Legend Number
        for (var i = 0; i <= maxIntensity; ++i) {
          var offset = (i * legendWidth) / maxIntensity;
          if (i > 0 && i < maxIntensity) {
            offset -= 0.5;
          } else if (i === maxIntensity) {
            offset -= 1;
          }
          let legendCardTitle = document.getElementById('legend' + period);
          let legendCardTitleRule = document.createElement('div');
          legendCardTitleRule.style.position = "absolute";
          legendCardTitleRule.style.left = offset + 5 + 'px';
          legendCardTitleRule.style.top = "2px";
          legendCardTitleRule.style.width =  "1px";
          legendCardTitleRule.style.height =  "3px";
          legendCardTitleRule.style.backgroundColor = "black";
          legendCardTitle.appendChild(legendCardTitleRule);

          let legendCardTitleNumber = document.createElement('div');
          legendCardTitleRule.style.position = "absolute";
          legendCardTitleRule.style.left = offset + 'px';
          legendCardTitleRule.style.top = "2px";
          legendCardTitleRule.style.textAlign = "center";
          legendCardTitleRule.style.fontSize = "0.8em";
          legendCardTitleNumber.style.fontWeight = 'bold';
          legendCardTitleRule.innerHTML = i;
          legendCardTitle.appendChild(legendCardTitleNumber);

        }
      },
      */

      // Current marker adding functionality

      toggleMarker(map, markerList) {
        if (map.getZoom() >= 12) {
          markerList.forEach(element => element.setVisible(true))
        } else {
          markerList.forEach(element => element.setVisible(false))
        }
      },

      // MOVED UP ^^^
      // addMarker(map, lat_lon, connectiontype, imsi, bounds, configData) {
      //   //let icon_3green = "https://i.imgur.com/vSpGkBd.png";
      //   //let icon_4green = "https://i.imgur.com/8jLOZnY.png";
      //   let icon_3yellow = "https://i.imgur.com/SU1eH1v.png";
      //   let icon_4yellow = "https://i.imgur.com/theJhNx.png";
      //   //let icon_cgreen = "https://i.imgur.com/CM5c7BE.png";
      //   let icon_cyellow = "https://i.imgur.com/2eE096C.png";
      //   let sel_icon = "";

      //   if (connectiontype === "3G") {
      //     // yellow triangle
      //     sel_icon = icon_3yellow;
      //   } else if (connectiontype === "LTE") {
      //     // yellow square
      //     sel_icon = icon_4yellow;
      //   } else {
      //     sel_icon = icon_cyellow;
      //   }

      //   let latlngStr = lat_lon.split(",", 2);
      //   let latlng = {lat: parseFloat(latlngStr[0]), lng: parseFloat(latlngStr[1])};

      //   let contentString =
      //     '<div id="content">' +
      //     //"<p></p>" +
      //     '<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">IMSI: </span> ' +
      //     imsi +
      //     "</p>" +
      //     '<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">Connection Type: </span> ' +
      //     connectiontype +
      //     "</p>" +
      //     "</div>";
      //   let infowindow = new google.maps.InfoWindow({
      //     content: contentString,
      //   });

      //   let marker = new google.maps.Marker({
      //     position: latlng,
      //     map: map,
      //     title: "Point",
      //     icon: sel_icon,
      //     visible: configData["site-settings"]["use_map"] === "markerclusters",
      //   });
      //   marker.addListener("click", function () {
      //     infowindow.open(map, marker);
      //   });
      //   if (typeof bounds !=='undefined')
      //     bounds.extend(marker.getPosition());
      //   this.markerList.push(marker);
      //   return marker;
      // },

      changeDataRegionTab(title) {
        this.$emit('changeDataRegionTab', title);
        this.loadingStatus = true;
        this.btnActivated = title;
      },

      dataVolumeRegionToggle() {
        let status = cardOpenStatusDirective.setDataVolumeMapStatus();
        if (status) {
          this.toggleStatus = !this.toggleStatus;
          if (this.toggleStatus) {
            this.icon1 = this.downIcon;
          } else {
            this.icon1 = this.rightIcon
          }
          this.$root.$emit('dataVolumeTrendsByRegionOpen', this.btnActivated)
        }
      },

      // initialMap(google) {
      //   let configData = configDirective.getConfigData();
      //   let heatMapData = [];
      //   let bound = new google.maps.LatLngBounds();
      //   let center = new google.maps.LatLng(configData['site-settings']['map_center'].split(',')[0], configData['site-settings']['map_center'].split(',')[1]);
      //   let zoom = configData['site-settings']['map_zoom'] ? configData['site-settings']['map_zoom'] : 3;
      //   //console.log('[DataVolumeByRegion.vue] mapDiv: data_volume_map');
      //   let el = null;
      //   try {
      //     el = document.getElementById('data_volume_map');
      //     if (typeof el === 'undefined') return;
      //   } catch (e) {
      //     //console.error(e);
      //     return;
      //   }
      //   console.log(el, 'what is el')
      //   const map = new google.maps.Map(el);
      //   map.setCenter(center);
      //   map.setZoom(zoom);
      //   map.setMapTypeId(google.maps.MapTypeId.ROADMAP);
      // }
    },
  };
</script>

<style>
  .data-volume-region-container {
    max-width: 100%;
    padding: 0 !important;
  }
  /*.gradient-body-width {*/
  /*  width: 250px;*/
  /*  height: 15px;*/
  /*  background: -webkit-linear-gradient(left, rgba(102, 255, 0, 0), rgb(102, 255, 0), rgb(147, 255, 0), rgb(193, 255, 0), rgb(238, 255, 0), rgb(244, 227, 0), rgb(249, 198, 0), rgb(255, 170, 0), rgb(255, 113, 0), rgb(255, 57, 0), rgb(255, 0, 0));*/
  /*}*/
  /*.legendImage {*/
  /*  width: 300px!important;*/
  /*}*/
</style>
